import { render, staticRenderFns } from "./ColorWays.vue?vue&type=template&id=339eb940"
import script from "./ColorWays.vue?vue&type=script&lang=js"
export * from "./ColorWays.vue?vue&type=script&lang=js"
import style0 from "./ColorWays.vue?vue&type=style&index=0&id=339eb940&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports